import Vue from 'vue'

const state = Vue.observable({
  quizId: null,
  quiz: null,
  questions: [],
  currentIndex: 0,
  answers: {},
  result: null,
  submitPromise: null
})

export const quizStore = {
  getState () {
    return state
  },
  setQuizPayload (quizId, quiz, questions) {
    state.quizId = quizId
    state.quiz = quiz
    state.questions = questions || []
    state.currentIndex = 0
    state.answers = {}
    state.result = null
    state.submitPromise = null
  },
  setAnswer (questionId, optionId) {
    Vue.set(state.answers, String(questionId), optionId)
  },
  nextQuestion () {
    if (state.currentIndex < state.questions.length - 1) {
      state.currentIndex += 1
    }
  },
  isAllAnswered () {
    if (!state.questions.length) return false
    return state.questions.every(q => {
      const id = String(q.id)
      return state.answers[id] != null && state.answers[id] !== undefined
    })
  },
  firstUnansweredIndex () {
    return state.questions.findIndex(q => {
      const id = String(q.id)
      return state.answers[id] == null || state.answers[id] === undefined
    })
  },
  goToQuestion (index) {
    if (index >= 0 && index < state.questions.length) {
      state.currentIndex = index
    }
  },
  setSubmitPromise (promise) {
    state.submitPromise = promise
  },
  setResult (result) {
    state.result = result
  },
  resetSession () {
    state.quizId = null
    state.quiz = null
    state.questions = []
    state.currentIndex = 0
    state.answers = {}
    state.result = null
    state.submitPromise = null
  },
  resetForRetake () {
    state.currentIndex = 0
    state.answers = {}
    state.result = null
    state.submitPromise = null
  }
}
